import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Shell from "@/components/Shell";
import AdminApp from "@/admin/AdminApp";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicesPage from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Resources from "@/pages/Resources";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Author from "@/pages/Author";
import NotFound from "@/pages/NotFound";

// Lenis momentum scrolling — skipped entirely for reduced-motion users.
const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const LangRoutes = ({ lang }) => (
  <>
    <Route index element={<Home />} />
    <Route path={lang === "en" ? "about" : "nosotros"} element={<About />} />
    <Route path={lang === "en" ? "services" : "servicios"} element={<ServicesPage />} />
    <Route path={`${lang === "en" ? "services" : "servicios"}/:slug`} element={<ServiceDetail />} />
    <Route path={lang === "en" ? "resources" : "recursos"} element={<Resources />} />
    <Route path="blog" element={<Blog />} />
    <Route path="blog/:slug" element={<BlogPost />} />
    <Route path="faq" element={<Faq />} />
    <Route path={lang === "en" ? "contact" : "contacto"} element={<Contact />} />
    <Route path="privacy-policy" element={<Legal doc="privacy" />} />
    <Route path="terms" element={<Legal doc="terms" />} />
    <Route path="accessibility" element={<Legal doc="accessibility" />} />
    <Route path="editorial-policy" element={<Legal doc="editorial" />} />
    <Route path="disclosures" element={<Legal doc="disclosures" />} />
    <Route path="author/escarling-martinez" element={<Author />} />
    <Route path="*" element={<NotFound />} />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <ScrollToTop />
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/" element={<Shell lang="en" />}>
          {LangRoutes({ lang: "en" })}
        </Route>
        <Route path="/es" element={<Shell lang="es" />}>
          {LangRoutes({ lang: "es" })}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
